import React, { useEffect } from "react";
import { retriveOrgCouponData } from "../api/PupilApi";
import Slider from "react-slick";
import banner1 from "../assets/banners/banner1.jpg";
import banner2 from "../assets/banners/banner2.jpg";
import banner3 from "../assets/banners/banner3.jpg";
import banner4 from "../assets/banners/banner4.jpg";

// Import Slick Carousel CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero = () => {
  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };

  // Banner data
  const banners = [
    {
      id: 1,
      image: banner1,
      title: "The Quality Ice Cream",
      text: "Need At One Place",
      text2: "Up to 50% Off",
    },
    {
      id: 2,
      image: banner2,
      title: "The Best Quality And ",
      text: "Rich Ice Cream",
      text2: "You Can Buy Here",
    },
    {
      id: 3,
      image: banner3,
      title: "Delicious &",
      text: "Premium Ice Cream Available",
      text2: "Up to 50% Off",
    },
    {
      id: 4,
      image: banner4,
      title: "Fresh",
      text: "Gourmet Ice Cream Ready",
      text2: "Up to 50% Off",
    },
  ];

  // Fetch and store coupon data
  useEffect(() => {
    retriveOrgCouponData()
      .then((response) => {
        const couponData = response.data.data[0]?.couponData || [];
        localStorage.setItem("couponData", JSON.stringify(couponData));
      })
      .catch((error) => {
        console.error("Error fetching coupon data:", error);
      });

    const storedCouponData = localStorage.getItem("couponData");
    if (storedCouponData) {
      console.log("Coupon data found in localStorage:", JSON.parse(storedCouponData));
    } else {
      console.log("No coupon data in localStorage.");
    }
  }, []);

  return (
    <div className="max-w-[1640px] mx-auto p-4">
      <Slider {...settings}>
        {banners.map((banner) => (
       <div key={banner.id} className="relative">
       {/* Responsive Image */}
       <img
         src={banner.image}
         alt={`Banner ${banner.id}`}
         className="w-full h-[50vh] sm:h-[60vh] md:h-[65vh] lg:h-[70vh] xl:h-[70vh] object-cover object-center rounded-t-lg shadow-lg"
       />
     
       {/* Gradient Overlay */}
       <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70 flex items-center justify-center px-6 sm:px-12 md:px-16 lg:px-24 xl:px-32">
         <div className="text-center max-w-3xl">
           {/* Title (if available) */}
           {banner.title && (
             <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-6xl font-bold text-white font-serif drop-shadow-lg mb-3">
               {banner.title}
             </h1>
           )}
     
           {/* Main Text */}
           <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-yellow-400 font-serif drop-shadow-md mb-3">
             {banner.text}
           </h2>
     
           {/* Subtext */}
           <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-gray-200 drop-shadow-md mb-6">
             {banner.text2}
           </p>
     
           {/* Buttons with Hover Effects */}
           <div className="flex justify-center gap-6">
             <a href="/">
               <button className="bg-orange-500 hover:bg-orange-600 transition-transform transform hover:scale-105 text-white font-bold py-3 px-6 md:px-8 lg:px-10 rounded-lg shadow-lg">
                 Read More
               </button>
             </a>
             <a href="/">
               <button className="bg-gray-500 hover:bg-gray-600 transition-transform transform hover:scale-105 text-white font-bold py-3 px-6 md:px-8 lg:px-10 rounded-lg shadow-lg">
                 Contact Us
               </button>
             </a>
           </div>
         </div>
       </div>
     </div>
     
      
        
        ))}
      </Slider>
    </div>
  );
};

export default Hero;



// <div className='max-h-[500px] relative'>
// {/* Overlay */}
// <div className='absolute w-full h-full text-gray-200 max-h-[500px] bg-black/60 flex flex-col justify-center'>
//   <h1 className='px-4 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold'>
//     THE<span className='text-orange-600'>QUALITY</span>
//   </h1>
//   <h1 className='px-4 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold'>
//     ICE CREAM <span className='text-orange-600'>Delivered</span>
//   </h1>
// </div>
// <img
//   className='w-full max-h-[500px] object-cover'
//   src={IceCream}
//   alt='Delicious Briyani'
// />
// </div>